<template>
  <div class="relative text-center mx-auto lg:mt-100">
    <div class="flex justify-center mb-20 lg:mb-58">
      <img class="object-cover h-186" src="/assets/images/empty-logos/empty-search.svg" alt="empty results">
    </div>
    <h2 class="text-2xl font-bold mb-16 lg:mb-28">Sorry, no results found.</h2>
    <div class="mb-24">
      Try adjusting your filter options to find more artworks.
    </div>
  </div>
</template>

<script>
export default {
  name: "default"
}
</script>

<style scoped>

</style>
